export enum EmailCategory {
  Inbox = 'Inbox',
  Sent = 'Sent Items',
  Drafts = 'Drafts',
  Deleted = 'Deleted Items',
}
